import { SUBJECTS } from '../constants';

// 科目名を取得する関数
export const getSubjectName = (subjectId) => {
  const subject = SUBJECTS.find((s) => s.id === subjectId);
  return subject ? subject.name : subjectId;
};

// 日本語名からIDへの変換関数
export const getSubjectIdFromName = (subjectName) => {
  const subject = SUBJECTS.find((s) => s.name === subjectName);
  return subject ? subject.id : null;
};

// 日本語名からIDへのマッピングオブジェクトを生成する関数
export const createSubjectNameToIdMap = () => {
  return SUBJECTS.reduce((map, subject) => {
    map[subject.name] = subject.id;
    return map;
  }, {});
}; 